module.exports = __webpack_public_path__ + "img/recnet-header.bce9b77c.png";